import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      props: true
    },
    {
      path: "https://github.com/WagnerSilvaRamos",
      name: "github"
    },
    {
      path: "https://www.linkedin.com/in/wagner-ramos-53a3116",
      name: "linkedin"
    }
  ]
});

export default router;
